(function () {
  function initTradeAccount(root) {
    if (!root || root.dataset.taReady === 'true') return;
    root.dataset.taReady = 'true';

    var views = ['dashboard', 'orders', 'pricing', 'directory'];
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"][data-ta-view]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ta-panel]'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentView = null;
    var nav = root.querySelector('.ta-nav');

    function updateNavStickyOffset() {
      if (!nav) return;
      var styles = getComputedStyle(document.documentElement);
      var headerHeight = parseFloat(styles.getPropertyValue('--header-height')) || 0;
      var announcementHeight = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
      var isSticky = parseFloat(styles.getPropertyValue('--header-is-sticky')) || 0;
      nav.style.top = headerHeight * isSticky + announcementHeight * isSticky + 'px';
    }

    updateNavStickyOffset();
    window.addEventListener('resize', updateNavStickyOffset);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateNavStickyOffset);
    }

    function normalizeHash(hash) {
      var value = (hash || '').replace(/^#/, '').toLowerCase();
      if (value === 'trade-directory-scroll' || value === 'directory') return 'directory';
      if (views.indexOf(value) !== -1) return value;
      return 'dashboard';
    }

    function scrollToTop() {
      var behavior = reduceMotion ? 'auto' : 'smooth';
      window.scrollTo({ top: 0, left: 0, behavior: behavior });
    }

    function setView(view, options) {
      options = options || {};
      var next = views.indexOf(view) !== -1 ? view : 'dashboard';
      var viewChanged = currentView !== null && currentView !== next;

      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-ta-view') === next;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-ta-panel') === next;
        panel.hidden = !match;
        panel.classList.toggle('is-active', match);

        if (match && !reduceMotion) {
          panel.classList.remove('is-active');
          void panel.offsetWidth;
          panel.classList.add('is-active');
        }
      });

      if (options.updateHash !== false) {
        var newHash = '#' + next;
        if (window.location.hash !== newHash) {
          if (options.replace) {
            history.replaceState(null, '', newHash);
          } else {
            history.pushState(null, '', newHash);
          }
        }
      }

      if (options.focusPanel) {
        var activePanel = root.querySelector('[data-ta-panel="' + next + '"]');
        if (activePanel) {
          activePanel.setAttribute('tabindex', '-1');
          activePanel.focus({ preventScroll: true });
        }
      }

      if (viewChanged && options.scroll !== false) {
        scrollToTop();
      }

      currentView = next;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setView(tab.getAttribute('data-ta-view'));
      });

      tab.addEventListener('keydown', function (event) {
        var index = tabs.indexOf(tab);
        var nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        setView(tabs[nextIndex].getAttribute('data-ta-view'));
      });
    });

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ta-goto]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      setView(trigger.getAttribute('data-ta-goto'), { focusPanel: true });
    });

    window.addEventListener('hashchange', function () {
      setView(normalizeHash(window.location.hash), { updateHash: false });
    });

    /* Orders filters */
    var searchInput = root.querySelector('[data-ta-orders-search]');
    var paymentSelect = root.querySelector('[data-ta-orders-payment]');
    var fulfillmentSelect = root.querySelector('[data-ta-orders-fulfillment]');
    var sortSelect = root.querySelector('[data-ta-orders-sort]');
    var resetButton = root.querySelector('[data-ta-orders-reset]');
    var showingCount = root.querySelector('[data-ta-orders-count]');
    var tbody = root.querySelector('[data-ta-orders-tbody]');
    var emptyMessage = root.querySelector('[data-ta-orders-empty]');
    var orderRows = tbody
      ? Array.prototype.slice.call(tbody.querySelectorAll('[data-ta-order-row]'))
      : [];

    function filterOrders() {
      if (!orderRows.length) return;

      var searchTerm = (searchInput.value || '').toLowerCase();
      var paymentStatus = (paymentSelect.value || '').toLowerCase();
      var fulfillmentStatus = (fulfillmentSelect.value || '').toLowerCase();
      var visibleCount = 0;

      orderRows.forEach(function (row) {
        var orderNumber = (row.dataset.orderNumber || '').toLowerCase();
        var rowPayment = (row.dataset.paymentStatus || '').toLowerCase();
        var rowFulfillment = (row.dataset.fulfillmentStatus || '').toLowerCase();

        var matchesSearch = !searchTerm || orderNumber.indexOf(searchTerm) !== -1;
        var matchesPayment = !paymentStatus || rowPayment === paymentStatus;
        var matchesFulfillment = !fulfillmentStatus || rowFulfillment === fulfillmentStatus;
        var visible = matchesSearch && matchesPayment && matchesFulfillment;

        row.classList.toggle('is-hidden', !visible);
        if (visible) visibleCount += 1;
      });

      if (showingCount) showingCount.textContent = String(visibleCount);
      if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
      if (tbody) tbody.hidden = visibleCount === 0;
    }

    function sortOrders() {
      if (!tbody || !orderRows.length || !sortSelect) return;

      var sortValue = sortSelect.value;
      var rowsArray = orderRows.slice();

      rowsArray.sort(function (a, b) {
        switch (sortValue) {
          case 'date-desc':
            return parseInt(b.dataset.date, 10) - parseInt(a.dataset.date, 10);
          case 'date-asc':
            return parseInt(a.dataset.date, 10) - parseInt(b.dataset.date, 10);
          case 'total-desc':
            return parseFloat(b.dataset.total) - parseFloat(a.dataset.total);
          case 'total-asc':
            return parseFloat(a.dataset.total) - parseFloat(b.dataset.total);
          default:
            return 0;
        }
      });

      rowsArray.forEach(function (row) {
        tbody.appendChild(row);
      });
      orderRows = rowsArray;
    }

    function resetFilters() {
      if (searchInput) searchInput.value = '';
      if (paymentSelect) paymentSelect.value = '';
      if (fulfillmentSelect) fulfillmentSelect.value = '';
      if (sortSelect) sortSelect.value = 'date-desc';
      filterOrders();
      sortOrders();
    }

    if (searchInput) searchInput.addEventListener('input', filterOrders);
    if (paymentSelect) paymentSelect.addEventListener('change', filterOrders);
    if (fulfillmentSelect) fulfillmentSelect.addEventListener('change', filterOrders);
    if (sortSelect) sortSelect.addEventListener('change', sortOrders);
    if (resetButton) resetButton.addEventListener('click', resetFilters);

    if (orderRows.length) sortOrders();

    /* Directory: edit-profile scroll */
    root.addEventListener('click', function (event) {
      var scrollTrigger = event.target.closest('[data-ta-scroll-to]');
      if (!scrollTrigger || !root.contains(scrollTrigger)) return;
      event.preventDefault();
      var targetId = scrollTrigger.getAttribute('data-ta-scroll-to');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;
      setView('directory', { updateHash: true, scroll: false });
      window.requestAnimationFrame(function () {
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    /* Clear stale optimistic-submit flag that previously hid the create form */
    try {
      sessionStorage.removeItem('ta-directory-form-submitted');
    } catch (err) {}

    setView(normalizeHash(window.location.hash), { replace: true, updateHash: true, scroll: false });
  }

  function boot() {
    var roots = document.querySelectorAll('.trade-account[data-section-type="trade-account"]');
    Array.prototype.forEach.call(roots, initTradeAccount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.trade-account[data-section-type="trade-account"]');
    if (root) initTradeAccount(root);
  });
})();
